// extracted by mini-css-extract-plugin
export default {"logoContainer":"Logo_logoContainer__BMSRt","logo":"Logo_logo__U4h2P","description":"Logo_description__+TinU"};